// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/@adyen/adyen-web/dist/es/adyen.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Match v5 input height */
.adyen-checkout__input-wrapper {
    height: 40px;
}

/* Placeholder color for holder name and other plain inputs */
.adyen-checkout__input-wrapper input::-moz-placeholder,
.adyen-checkout__input::-moz-placeholder {
    color: #707070;
    font-weight: 200;
}
.adyen-checkout__input-wrapper input::placeholder,
.adyen-checkout__input::placeholder {
    color: #707070;
    font-weight: 200;
}
`, "",{"version":3,"sources":["webpack://./overrides/app/vendors/adyen/style/adyenCheckout.css"],"names":[],"mappings":"AAEA,0BAA0B;AAC1B;IACI,YAAY;AAChB;;AAEA,6DAA6D;AAC7D;;IAEI,cAAc;IACd,gBAAgB;AACpB;AACA;;IAEI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["@import '~@adyen/adyen-web/styles/adyen.css';\n\n/* Match v5 input height */\n.adyen-checkout__input-wrapper {\n    height: 40px;\n}\n\n/* Placeholder color for holder name and other plain inputs */\n.adyen-checkout__input-wrapper input::-moz-placeholder,\n.adyen-checkout__input::-moz-placeholder {\n    color: #707070;\n    font-weight: 200;\n}\n.adyen-checkout__input-wrapper input::placeholder,\n.adyen-checkout__input::placeholder {\n    color: #707070;\n    font-weight: 200;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
